import { ApiEnv } from '@appbolaget/aware-http';

export class ChangeApiLanguage {
    static type = '[App] Change api language';
}

export class AppReady {
    static readonly type = '[App] Platform is ready';
}

export class SetApiEnv {
    static readonly type = '[Api] Set api env';
    constructor(public env: ApiEnv) {}
}

export class ShowUnitSearch {
    static readonly type = '[Topbar] Show unit search';
}
